var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-box",class:[_vm.isSliderOpen && 'slider-open'],on:{"click":_vm.toggleSlider}},[_c('span',{staticClass:"slider-block"})])}
var staticRenderFns = []

export { render, staticRenderFns }